export const CREATION_STEP_MAPPING = [
  "Event type",
  "Basic information",
  "Additional details",
  "Review",
];
